<template>
    <div class="searchBtn group/sideNav col-span-2 h-10
    grid grid-cols-subgrid rounded-md cursor-pointer 
    transition-colors overflow-hidden
    justify-items-center items-center"
    >

        <div
            class="flex items-center justify-center cursor-pointer"
            @click="handleSearchIconClick"
        >
            <UIcon name="i-heroicons-magnifying-glass" class="w-6 h-6 text-navigation-icon group-hover/sideNav:text-navigation-icon-hover" />
        </div>

        <SideNavigationGridExpander class="col-start-2 justify-self-start" :isClosed="isNavClosed">
        <div ref="searchInputWrapper" class=" w-full min-w-0 self-center">
            <UInput color="primary" variant="outline" placeholder="Search..."
            class="mr-1 focus:ring-1"
            :ui="{variant: { outline: 'focus:ring-1 focus:ring-inset'}}"
            v-model="searchValue"
            />
        </div>
        </SideNavigationGridExpander>
    
    </div>

</template>

<script setup lang="ts">
import type { Navigation } from "~/types/api/navigation";

interface Props {
    links: Navigation[]
}

const props = defineProps<Props>()

const isNavClosed = useState<boolean>('isNavClosed');

const searchValue = ref('');
const searchInputWrapper = ref<HTMLElement | null>(null);

const emit = defineEmits(['searchResults'])

const focusSearchInput = () => {
    searchInputWrapper.value?.querySelector('input')?.focus()
}

const handleSearchIconClick = async () => {
    if (isNavClosed.value) {
        isNavClosed.value = false
        await nextTick()
        requestAnimationFrame(focusSearchInput)
        return
    }

    focusSearchInput()
}


/// SEARCH LOGIC
const searchByName = (array:Navigation[], searchVal:string):Navigation[] => {
  const filteredResult = [];
  const searchString = searchVal.toLowerCase();
  if(searchString != ''){

        for (const obj of array) {
        if (obj.label.toLowerCase().includes(searchString)) {
        // Include the object if its name includes the search input
        filteredResult.push({ ...obj, subItems: searchByName(obj.subItems || [], searchString) });
        } else if (obj.subItems && obj.subItems.length > 0) {
        // If the current object has subItems, recursively search in subItems
        const result = searchByName(obj.subItems, searchString);

        // Include the current object in the result only if there are matches in subItems
        if (result.length > 0) {
            filteredResult.push({ ...obj, subItems: result });
        }
        }
    }
  }
  return filteredResult;
}

const computedSearch = computed(() => {
    return searchByName(props.links, searchValue.value)
})

watch(computedSearch, (newVal) => {
    emit('searchResults', newVal)
})

</script>